import { integrations, isLoading } from '../state'
import { integrationService } from '../../../services/integration/integration-service'
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Checks authentication status for all integrations
 * @param {Function} t - Translation function passed from parent
 */
export const checkAuth = async (t) => {
  try {
    await integrationService.checkAllIntegrations(integrations.value)
  } catch (error) {
    responseHandlerService.handleError(
      error,
      t('settings.components.integrations.responseHandler.errors.authenticationProcess')
    )
  } finally {
    setTimeout(() => {
      integrations.value.forEach((integration) => {
        integration.loading = false
      })
      isLoading.value = false
    }, 1000)
  }
}